import { Pages, PagesInitialState, ReduxAction } from "../models";
import { PagesType } from "../types";

export const PagesState = (state: Pages = PagesInitialState, action?: ReduxAction): Pages => {
    if (!action) return state;

    switch (action.type) {
        case PagesType.SET_ABOUT_US_CONTENT:
            return { ...state, aboutUs: { ...state.aboutUs, ...action.payload, loaded: true } };
        case PagesType.SET_PACKAGE_GUIDE_CONTENT:
            return { ...state, packageGuide: { ...state.packageGuide, ...action.payload, loaded: true } };
        case PagesType.SET_APP_LINKS_CONTENT:
            return { ...state, apps: { ...state.apps, data: { ...state.apps.data, ...action.payload }, loaded: true } };
    }

    return state;
};